module.exports = __webpack_public_path__ + "static/media/gold-box.b0367ca6.png";